import util from '../util'

let controller = 'OperadoresRetaguarda'
export default Object.assign({}, util.GetCrud(controller, null), {
    GetAcessoUsuario: function (dto, options) {
        if (options && options.data) dto.data = options.data
        return util.Axios.GetAll(controller + "/GetAcessoUsuario", dto)
    },
    AtivarUsuario: function (id) {
        return util.Axios.Post(controller + `/PostAtivarUsuario?id=${id}`, {})
    },
    DesativarMfaRetaguarda: function (id) {
        return util.Axios.Post(controller + `/DesativarMfaRetaguarda?id=${id}`, {})
    },
    ResetarMfaFisico: function (id) {
        return util.Axios.Post(controller + `/MfaFisico/Resetar?codigoUsuario=${id}`, {})
    },
})



